import { axios } from "@/services/axios";

export async function postNumberBlock(formData) {
  return await axios.post("/numberblock/", formData)
}